var _effectorFileName = "/builds/gmini/front-common/src/Services/UserClassifierRepoService/Node/Node.ts";
// eslint-disable-next-line import/no-cycle
import { UserClassifierNode } from "./UserClassifierNode"; // eslint-disable-next-line import/no-cycle

import { UserClassifierRepoFolderNode } from "./UserClassifierRepoFolderNode"; // eslint-disable-next-line import/no-cycle

import { UserClassifierRepoNode } from "./UserClassifierRepoNode"; // eslint-disable-next-line import/no-cycle

import { AssemblyClassifierNode } from "./AssemblyClassifierNode";
export var Node;

(function (_Node) {
  function getKey(ref) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return map[ref.type].getKey(ref);
  }

  _Node.getKey = getKey;

  function getParentKey(node) {
    var ns = map[node.type];
    var fn = 'getParentKey' in ns ? ns.getParentKey : null; // eslint-disable-next-line @typescript-eslint/no-explicit-any

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return fn && fn(node);
  }

  _Node.getParentKey = getParentKey;

  var getByRef = _Node.getByRef = function (nodes, ref) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var ns = map[ref.type];
    return ns.getByKey(nodes, getKey(ref));
  };
})(Node || (Node = {}));

var map = {
  UserClassifierRepoNode: UserClassifierRepoNode,
  UserClassifierRepoFolderNode: UserClassifierRepoFolderNode,
  UserClassifierNode: UserClassifierNode,
  AssemblyClassifierNode: AssemblyClassifierNode
};